import { useState } from "react";
import { testTurn } from "../../services/guides";
import type { CharacterProfile } from "../../types/guide";

interface Msg {
  kind: "user" | "guide" | "sys";
  text: string;
}

export function TextBench({ profile }: { profile: CharacterProfile }) {
  const [messages, setMessages] = useState<Msg[]>([
    { kind: "sys", text: "Text chat runs against the current (unsaved) draft. Nothing is persisted." },
  ]);
  const [input, setInput] = useState("");
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function send() {
    const message = input.trim();
    if (!message || busy) return;
    setInput("");
    setMessages((m) => [...m, { kind: "user", text: message }]);
    setBusy(true);
    try {
      const data = await testTurn(sessionId, message, profile);
      setSessionId(data.sessionId);
      setMessages((m) => [...m, { kind: "guide", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { kind: "sys", text: `error: ${e instanceof Error ? e.message : e}` }]);
    } finally {
      setBusy(false);
    }
  }

  function reset() {
    setSessionId(null);
    setMessages([{ kind: "sys", text: "New test session." }]);
  }

  return (
    <div className="bench">
      <div className="chat-log">
        {messages.map((m, i) => (
          <div key={i} className={`msg ${m.kind}`}>{m.text}</div>
        ))}
      </div>
      <div className="chat-input-row">
        <input
          type="text"
          placeholder="Say something to this companion…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()}
        />
        <button className="btn btn-primary" onClick={send} disabled={busy}>Send</button>
        <button className="btn" title="New test session" onClick={reset}>↺</button>
      </div>
    </div>
  );
}
